// Smart validation for Indian mobile numbers.
// Rules (mirrored on the backend server.py `_phone` validator):
//   1. Exactly 10 digits (after stripping non-digits).
//   2. First digit must be 6, 7, 8 or 9 (valid Indian mobile prefixes).
//   3. Not all-same-digit (e.g. 9999999999, 8888888888).
//   4. Not a purely sequential run of digits (1234567890, 9876543210, etc.).
// Returns { ok: true } or { ok: false, msg: string }.
export function validateIndianMobile(input) {
  const digits = (input || "").replace(/\D/g, "");
  if (digits.length !== 10) {
    return { ok: false, msg: "Please enter a valid 10-digit mobile number." };
  }
  if (!/^[6-9]/.test(digits)) {
    return { ok: false, msg: "Indian mobile numbers start with 6, 7, 8 or 9." };
  }
  if (/^(\d)\1{9}$/.test(digits)) {
    return { ok: false, msg: "Please enter a valid mobile number." };
  }
  // Detect strictly sequential ascending or descending patterns (mod 10)
  let asc = true;
  let desc = true;
  for (let i = 1; i < digits.length; i++) {
    const diff = (Number(digits[i]) - Number(digits[i - 1]) + 10) % 10;
    if (diff !== 1) asc = false;
    if (diff !== 9) desc = false;
  }
  if (asc || desc) {
    return { ok: false, msg: "Please enter a valid mobile number." };
  }
  return { ok: true };
}
